import { Stage, stageFromString } from '@eventbrite/webapp-constants';
import { EmbeddedMetricsLogger } from '@eventbrite/openapi-service';

// ---------------------------------------------------------------------------
// Shared infrastructure for API route handlers
// ---------------------------------------------------------------------------

/** Shared metrics logger used across all API route dependency calls. */
export const dependencyMetrics = new EmbeddedMetricsLogger('dependency-metrics');

/** SSR-level metrics logger for page rendering and API call timings. */
export const ssrMetrics = new EmbeddedMetricsLogger('organizer-profile-ssr');

/**
 * Maps the current deployment stage to either PROD or TEST for remote
 * service clients that only distinguish between those two environments.
 */
export const getRemoteStage = (): Stage => {
  const appStage = stageFromString(process.env.STAGE ?? Stage.TEST);
  return appStage === Stage.PROD ? Stage.PROD : Stage.TEST;
};

/**
 * Creates a lazy singleton: the factory is called at most once, on first
 * invocation, and the result is cached for all subsequent calls.
 */
export const lazySingleton = <T>(factory: () => T): (() => T) => {
  let instance: T;
  return () => (instance ??= factory());
};
